import { render } from "./LogoSalon.vue?vue&type=template&id=cd12bc8c&scoped=true"
import script from "./LogoSalon.vue?vue&type=script&lang=js"
export * from "./LogoSalon.vue?vue&type=script&lang=js"

import "./LogoSalon.vue?vue&type=style&index=0&id=cd12bc8c&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd12bc8c"]])

export default __exports__